export default __webpack_public_path__ + "static/media/juice-fruit-r-mobile@2x.f1642c7e.png";